import React from 'react'
import whatsAppWallpaper from '../../../../../assets/static/images/whatsapp-wallpaper.svg'
import ScrollToLastMessage from '../../other/ScrollToLastMessage'
import DateFormatView from '../../../../../itrust_common/components/others/DateFormatView'

export default function WhatsAppMessageListing(props) {
  const { patientChatLogs } = props

  const getMessageData = (log) => {
    return (
      <p className='text-right mb-0 font-size-12'>
        <DateFormatView dateTime={log.created_at} />
        {log.message_type == 'business' && <span className='ml-3 font-size-18 whatsapp-error-msg'>
          {log.other_details?.details ?
            <span className='text-danger'><i className="las la-exclamation-circle font-size-20 custom-tooltip" data-title={log.other_details?.details}></i></span> :
            <>
              {(log.status == 'initiate' || log.status == 'sent') ?
                <i className="las la-check"></i> :
                <i className={`las la-check-double ${log.status == 'read' && 'text-info'}`}></i>
              }
            </>
          }
        </span>}
      </p>
    )
  }

  const getImageData = (log) => {
    return (
      <>
        <div className='my-3'>
          <img src={log.whatsapp_media_attributes.file.url} alt='Image' className='w-100 height-18 border-radius-6' />
        </div>
      </>
    )
  }

  return (
    <div className='position-relative'>
      <div className='p-5 whatsapp-chat-listing overflow-auto' style={{ backgroundImage: `url(${whatsAppWallpaper})` }}>
        <div className='d-flex flex-column'>
          {patientChatLogs.map(log => <div className={`${log.message_type == 'patient' ? 'whatsapp-incoming-msg' : 'whatsapp-outgoing-msg'} whatsapp-msg border-radius-6 py-2 px-4 mb-4 position-relative font-size-14`}>
            {log.whatsapp_media_attributes?.file?.url && getImageData(log)}
            <p className='mb-0'>{log.body}</p>
            {getMessageData(log)}
            <div className={`message-corner position-absolute ${log.message_type == 'patient' ? 'incoming-message-corner' : 'outgoing-message-corner'}`}></div>
          </div>)}
        </div>
      </div>
      <div className='position-absolute scroll-bottom-btn'>
        <ScrollToLastMessage key={patientChatLogs.length} chatContainerClass={"whatsapp-chat-listing"} />
      </div>
    </div>
  )
}
